<template>
  <v-row no-gutters>
    <v-col v-if="contact != null">
      <v-row no-gutters class="mt-3">
        <v-col cols="12" sm="6" md="4" class="pr-2">
          <span>Company name:</span>
          <input class="form-control" v-model="contact.company_contact_name" />
        </v-col>

        <v-col cols="12" sm="6" md="2" class="px-2">
          <span>First name:</span>
          <input class="form-control" v-model="contact.contact_info.first_name" />
        </v-col>

        <v-col cols="12" sm="6" md="2" class="px-2">
          <span>Last name:</span>
          <input class="form-control" v-model="contact.contact_info.last_name" />
        </v-col>

        <v-col cols="12" sm="6" md="2" class="px-2">
          <span>Email:</span>
          <input class="form-control" v-model="contact.contact_info.email" />
        </v-col>

        <v-col cols="12" sm="6" md="2" class="pl-2">
          <span>Phone:</span>
          <input class="form-control" v-model="contact.contact_info.phone" />
        </v-col>
      </v-row>

      <v-divider class="my-5"></v-divider>

      <v-row no-gutters>
        <v-col cols="12" sm="6" md="4" class="pr-2">
          <span>Address line 1</span>
          <input class="form-control" v-model="contact.address.line_1" />
        </v-col>

        <v-col cols="12" sm="6" md="4" class="px-2">
          <span>Address line 2</span>
          <input class="form-control" v-model="contact.address.line_2" />
        </v-col>

        <v-col cols="12" sm="6" md="4" class="pl-2">
          <span>Address line 3</span>
          <input class="form-control" v-model="contact.address.line_3" />
        </v-col>
      </v-row>

      <!-- <v-divider></v-divider> -->

      <v-row no-gutters class="mt-4">
        <v-col cols="12" sm="5" md="3" class="pr-2">
          <span>City:</span>
          <input class="form-control" v-model="contact.address.city" />
        </v-col>

        <v-col cols="12" sm="4" md="2" class="px-2">
          <span>Postcode:</span>
          <input class="form-control" v-model="contact.address.postcode" />
        </v-col>

        <v-col cols="12" sm="5" md="3" class="px-2">
          <span>State:</span>
          <input class="form-control" v-model="contact.address.state" />
        </v-col>

        <v-col cols="12" sm="6" md="4" class="pl-2">
          <span>Country:</span>
          <v-autocomplete
            :items="sortedCountriesList"
            class="form-control"
            v-model="contact.address.code_country"
            item-value="code"
            item-text="name"
            flat
            solo
            clearable
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import constant from "../../const"
export default {
  props: ["value"],
  components: {},

  data() {
    return {
      contact: this.value,

      countries: [],
    }
  },

  created() {
    this.loadCountriesList()
  },
  watch: {
    value() {
      this.contact = this.value
    },
  },

  methods: {
    /**
     * Get country list
     */
    loadCountriesList() {
      this.$https.get("/api/countries").then((resp) => {
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          this.countries = resp.data.data
        } else {
          this.countries = []
        }
      })
    },
  },
  computed: {
    sortedCountriesList: function () {
      return this.countries.sort(function (a, b) {
        return ("" + a.name).localeCompare(b.name)
      })
    },
  },
}
</script>

<style>
</style>
